export default __webpack_public_path__ + "static/media/WHERE.c25a7f01.png";